import React from 'react';
import { X } from 'lucide-react';

const SEEN_KEY = 'rv_meta_reminder_seen';

export const metaReminderSeen = () => {
  try { return localStorage.getItem(SEEN_KEY) === '1'; } catch { return true; }
};

export const markMetaReminderSeen = () => {
  try { localStorage.setItem(SEEN_KEY, '1'); } catch { /* ignore */ }
};

// iter272 — One-time, dismissable reminder for the optional Meta consent.
// Both choices have equal prominence; declining never blocks the signup.
const EMAIL_SEEN_KEY = 'rv_email_reminder_seen';
export const emailReminderSeen = () => {
  try { return localStorage.getItem(EMAIL_SEEN_KEY) === '1'; } catch { return true; }
};
export const markEmailReminderSeen = () => {
  try { localStorage.setItem(EMAIL_SEEN_KEY, '1'); } catch { /* ignore */ }
};

const META_BODY = (
  <>RVINCENTE è gratuita. Condividere i dati di registrazione con <strong className="text-white">Meta</strong> ci aiuta a misurare le nostre pubblicità e a mantenerla tale.</>
);

export const MetaConsentReminder = ({
  open, onAccept, onDecline, onClose,
  title = 'Ci dai una mano?', body = META_BODY, testId = 'meta-consent-reminder',
}) => {
  if (!open) return null;
  const btn = 'flex-1 h-12 rounded-xl text-sm font-bold border border-gray-600 bg-[#2A2A2A] text-white hover:border-[#F5A623] transition-colors';
  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-[60] p-4" data-testid={testId}>
      <div className="relative w-full max-w-sm bg-[#1E1E1E] border border-gray-700 rounded-2xl p-6">
        <button type="button" onClick={onClose} className="absolute right-3 top-3 p-1 text-gray-500 hover:text-white" aria-label="Chiudi" data-testid={`${testId}-close`}>
          <X className="w-5 h-5" />
        </button>
        <h3 className="text-lg font-bold text-white mb-2 pr-6">{title}</h3>
        <p className="text-sm text-gray-300 mb-2">{body}</p>
        <p className="text-xs text-gray-500 mb-5">
          È facoltativo: l'app funziona allo stesso modo in entrambi i casi e puoi cambiare idea quando vuoi.
        </p>
        <div className="flex gap-3">
          <button type="button" onClick={onDecline} className={btn} data-testid={`${testId}-decline`}>Continua senza</button>
          <button type="button" onClick={onAccept} className={btn} data-testid={`${testId}-accept`}>Accetto</button>
        </div>
      </div>
    </div>
  );
};

export const EmailConsentReminder = (props) => (
  <MetaConsentReminder
    {...props}
    title="Restiamo in contatto?"
    body="Con notifiche ed email ti avvisiamo quando escono le analisi delle partite e le novità di RVincente."
    testId="email-consent-reminder"
  />
);
